var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBasicactionFunctionalOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete-basicaction-functional-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 20,
    viewBox: "0 0 19.999 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M381.1,1812.1h-3.811v-.1c0-1.627-1.026-2.951-2.287-2.951H368.48c-1.231,0-2.231,1.264-2.278,2.838,0,.038-.009.075-.009.114v.1h-3.833a.625.625,0,1,0,0,1.249h1.883v12.572a3.123,3.123,0,0,0,3.122,3.124h8.756a3.123,3.123,0,0,0,3.122-3.124v-12.572h1.86a.625.625,0,1,0,0-1.249Zm-13.661-.057c0-.04.007-.08.008-.123.029-.957.566-1.625,1.03-1.625H375c.491,0,1.039.728,1.039,1.7v.1h-8.6Zm10.552,13.878a1.875,1.875,0,0,1-1.873,1.874h-8.756a1.875,1.875,0,0,1-1.873-1.874v-12.558h.7v.019h11.1v-.019h.7Z",
    transform: "translate(-361.734 -1809.048)",
    fill: "#52555e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M369.733,1817.487a.624.624,0,0,0-.624.624v7.756a.625.625,0,0,0,1.249,0v-7.756A.624.624,0,0,0,369.733,1817.487Z",
    transform: "translate(-362.963 -1810.455)",
    fill: "#52555e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M373.619,1817.487a.624.624,0,0,0-.624.624v7.756a.625.625,0,0,0,1.249,0v-7.756A.624.624,0,0,0,373.619,1817.487Z",
    transform: "translate(-363.611 -1810.455)",
    fill: "#52555e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M377.505,1817.487a.624.624,0,0,0-.624.624v7.756a.625.625,0,0,0,1.249,0v-7.756A.624.624,0,0,0,377.505,1817.487Z",
    transform: "translate(-364.259 -1810.455)",
    fill: "#52555e"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 19.99,
    height: 19.999,
    transform: "translate(0.009 0.001)",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBasicactionFunctionalOutline);
export default __webpack_public_path__ + "static/media/delete-basicaction-functional-outline.04fc51bbcb801e5b03ba808864f16009.svg";
export { ForwardRef as ReactComponent };